var VideoJsUtils = (function () {
	var defaultTextTrack = "",
	
		addTextTracks = function (player, subtitles) {
			for (var id in subtitles) {
				addTextTrack(player, id, subtitles[id]);
			}
		},
		
		addTextTrack = function (player, id, params) {
			if (!params.urls.vtt || getTextTrack(player, id) != null) return;

			var track = document.createElement("track");
			track.setAttribute("id", id);
			track.setAttribute("label", params.label);
			track.setAttribute("src", params.urls.vtt);
			track.setAttribute("srclang", id);
			track.setAttribute("kind", "subtitles");
			if (params.isDefault) {
				track.setAttribute("default", "");
				defaultTextTrack = id;
			}

			player.appendChild(track);
		},

		selectTextTrack = function (player, id) {
			if (!hasTextTracks(player)) return;
			hideTextTracks(player);
			var index = getTextTrackIndex(player, id);

			if (index >= 0)
				player.textTracks[index].mode = "showing";

		},

		// private
		getTextTrack = function (player, id) {
			if (!hasTextTracks(player)) return null;

			for (var i = 0; i < player.textTracks.length; i++) {
				if (player.textTracks[i].id == id)
					return player.textTracks[i];
			}

			return null;
		},

		getTextTrackIndex = function (player, id) {
			if (!hasTextTracks(player)) return null;

			for (var i = 0; i < player.textTracks.length; i++) {
				if (player.textTracks[i].id == id)
					return i;
			};

			return -1;
		},

		hasTextTracks = function (player) {
			return player != null && player.textTracks != null;
		},

		hideTextTracks = function (player) {
			if (!hasTextTracks(player)) return;
			for (var i = 0; i < player.textTracks.length; i++) {
				player.textTracks[i].mode = "hidden";
			}
		};

	return {
		addTextTrack: addTextTrack,
		addTextTracks: addTextTracks,
		selectTextTrack: selectTextTrack,
		hideTextTracks: hideTextTracks,
		defaultTextTrack: defaultTextTrack
	};
})();